/* eslint-disable */
import React, { ChangeEvent } from "react";
import TextField from "@material-ui/core/TextField";
import { isIE } from "react-device-detect";
import Autocomplete from "@material-ui/lab/Autocomplete";
import { FormattedMessage, MessageDescriptor } from "react-intl";
import { useStyles } from "./styles";

type Props = {
  options: any[];
  getOptionLabel: (option: any) => any;
  inputLabel: MessageDescriptor;
  onChange: (event: ChangeEvent<{}>, value: any) => void;
  defaultValue?: any;
  inputLabelClassName?: string;
  className?: string;
  helperText?: JSX.Element;
  error?: boolean;
  filterOptions?: any;
};

export const ComboBoxField: React.FC<Props> = (props: Props) => {
  const classes = useStyles();
  const {
    options,
    inputLabel,
    getOptionLabel,
    defaultValue,
    inputLabelClassName,
    className,
    onChange,
    helperText,
    error,
    filterOptions,
  } = props;
  return (
    <Autocomplete
      id="combo-box-demo"
      options={options}
      getOptionLabel={getOptionLabel}
      renderInput={(params) => (
        <TextField
          {...params}
          label={<FormattedMessage {...inputLabel} />}
          variant="outlined"
          InputLabelProps={
            inputLabelClassName
              ? { classes: { root: inputLabelClassName }, shrink: isIE ? true : undefined }
              : undefined
          }
          helperText={helperText}
          error={error}
          FormHelperTextProps={{ classes: { root: classes.helperText } }}
          classes={{ root: classes.textField }}
        />
      )}
      defaultValue={defaultValue ? defaultValue : undefined}
      classes={{ root: className }}
      onChange={onChange}
      filterOptions={filterOptions}
    />
  );
};
